import { useQuery } from "@apollo/client";
import { Box } from "@mui/material";
import { ReactElement } from "react";

import {
  GetCampaignMessageStatusQuery,
  GetCampaignMessageStatusQueryVariables,
} from "~frontend/__generated__/graphql";
import { AsyncWrapper } from "~frontend/components/AsyncWrapper";
import Loading from "~frontend/components/Loading";
import { GET_CAMPAIGN_MESSAGE_STATUS } from "~frontend/graphql/campaigns";
import { palette } from "~frontend/theme";

import { CarrierFilteringTable } from "./CarrierFilteringTable";
import ErrorCodeTable from "./ErrorCodeTable";
import SendStatusTable from "./SendStatusTable";

export default function CampaignMessageStatusTable({
  campaignShortId,
}: {
  campaignShortId: number;
}): ReactElement {
  const { data, loading, error } = useQuery<
    GetCampaignMessageStatusQuery,
    GetCampaignMessageStatusQueryVariables
  >(GET_CAMPAIGN_MESSAGE_STATUS, {
    variables: {
      input: {
        shortId: campaignShortId,
      },
    },
  });

  return (
    <AsyncWrapper data={data} loading={loading} errors={[error]}>
      {({ getCampaignByShortId: { messageStatusBreakdown } }) => {
        if (!messageStatusBreakdown) {
          return <Loading />;
        }

        return (
          <Box>
            <Box>
              <ErrorCodeTable messageStatusBreakdown={messageStatusBreakdown} />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", mt: 6 }}>
              <Box
                sx={{
                  flex: 1,
                  marginRight: "20px",
                  backgroundColor: palette.lightestGray,
                }}
              >
                <SendStatusTable
                  messageStatusBreakdown={messageStatusBreakdown}
                />
              </Box>
              <Box sx={{ flex: 1, backgroundColor: palette.lightestGray }}>
                <CarrierFilteringTable
                  messageStatusBreakdown={messageStatusBreakdown}
                />
              </Box>
            </Box>
          </Box>
        );
      }}
    </AsyncWrapper>
  );
}
